import { render, staticRenderFns } from "./Degree.vue?vue&type=template&id=76ccf01e&"
import script from "./Degree.vue?vue&type=script&lang=js&"
export * from "./Degree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports